import type { BillingSubscriptionFee, PeriodUnit, SubscriptionFees } from '@cvo/domain';

/** A subscription fee entry from either the Plans catalog (multi-currency) or the Billing endpoint (single-currency, CVO-19112). */
export type AnySubscriptionFee = SubscriptionFees | BillingSubscriptionFee;

/** Billing fees quote one fixed currency; Plans-catalog fees carry a price per currency. */
export function isBillingFee(fee: AnySubscriptionFee): fee is BillingSubscriptionFee {
  return !Array.isArray(fee.gross);
}

/** Normalized single-currency price resolved from either the billing or plans fee shape. */
export interface ResolvedFeePrice {
  gross: string;
  net: string;
  currency: string;
}

export interface FeeValues {
  signUpFee?: AnySubscriptionFee
  renewalFee?: AnySubscriptionFee
  signUpPrice?: ResolvedFeePrice
  renewalPrice?: ResolvedFeePrice
}

export interface FormattedFeeValues {
  signUpPrice: string
  renewalPrice: string
}

export type PeriodUnitWithOneTime = PeriodUnit | 'ONCE';
export interface FeePeriodWithOneTime {
  unit: PeriodUnitWithOneTime
  amount: number
}
export interface FeePrices {
  signUp: {
    gross: string
    net: number
  },
  renewal: {
    gross: string
  }
}